import React, {useEffect} from "react";
import { motion } from "framer-motion";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import Breadcrumb from "../Components/Breadcrumb";
import WhatsappAutomationSteps from "../Components/WhatsappAutomationSteps";
import Testimonials from "../Components/Testimonials";
import Cta from "../Components/Cta";
import { chooseYourIndustry } from "../Data";
import IndustryTabs from "../Components/IndustryTabs";
import SchemaMarkup from "../Components/SchemaMarkup";
import CollectionPageSchema from "../Schema/CollectionPageSchema";
import ItemListSchema from "../Schema/ItemListSchema";
import BreadcrumbSchema from "../Schema/BreadcrumbSchema";
import WebPageSchema from "../Schema/WebpageSchema";

const headingVariant = {
  hidden: {
    opacity: 0,
    y: 50,
    filter: "blur(10px)",
  },
  visible: {
    opacity: 1,
    y: 0,
    filter: "blur(0px)",
    transition: {
      duration: 0.8,
      ease: [0.22, 1, 0.36, 1],
    },
  },
};

const textVariant = {
  hidden: {
    opacity: 0,
    y: 35,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      delay: 0.2,
      duration: 0.7,
    },
  },
};

const gridVariant = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.12,
      delayChildren: 0.25,
    },
  },
};

const cardVariant = {
  hidden: {
    opacity: 0,
    y: 70,
    scale: 0.92,
    filter: "blur(8px)",
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    filter: "blur(0px)",
    transition: {
      duration: 0.7,
      ease: [0.22, 1, 0.36, 1],
    },
  },
};

const IndustryCard = ({ item }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  return (
    <motion.div
      className="choose-industry-card"
      variants={cardVariant}
      whileHover={{ y: -10, scale: 1.03 }}
      transition={{ type: "spring", stiffness: 260, damping: 18 }}
    >
      <motion.div
        className="choose-industry-icon-wrapper"
        whileHover={{ scale: 1.1 }}
        transition={{ duration: 0.6 }}
      >
        <img src={item.icon} alt={`${item.prefix} ${item.number} ${item.suffix} ${item.desc} | Onbbits`} />
      </motion.div>

      <h3 className="card-heading" ref={ref}>
        {item.prefix}
        {inView && (
          <CountUp start={0} end={item.number} duration={2} />
        )}
        {item.suffix}
      </h3>

      <p className="section-text">{item.desc}</p>
    </motion.div>
  );
};

const Industries=()=>{

useEffect(() => {
    document.title =
      "WhatsApp Solutions for Every Industry | ONBBITS";

    const metaDesc = document.querySelector("meta[name='description']");
    if (metaDesc) {
      metaDesc.setAttribute(
        "content",
        "Discover industry-specific WhatsApp automation for healthcare, education, retail, real estate, finance and more with ONBBITS."
      );
    }

     const canonical = document.querySelector("link[rel='canonical']");
  if (canonical) {
    canonical.setAttribute("href", "https://onbbits.io/industries");
  }

  const ogTitle = document.querySelector("meta[property='og:title']");
  if (ogTitle) {
    ogTitle.setAttribute(
      "content",
      "WhatsApp Solutions for Every Industry | ONBBITS"
    );
  }

    const ogDesc = document.querySelector("meta[property='og:description']");
  if (ogDesc) {
    ogDesc.setAttribute(
      "content",
      "Discover industry-specific WhatsApp automation for healthcare, education, retail, real estate, finance and more with ONBBITS."
    );
  }

  const ogUrl = document.querySelector("meta[property='og:url']");
  if (ogUrl) {
    ogUrl.setAttribute("content", "https://onbbits.io/industries");
  }

    const ogImage = document.querySelector("meta[property='og:image']");
  if (ogImage) {
    ogImage.setAttribute(
      "content",
      "https://onbbits.io/Images/templates.webp"
    );
  }

    const twitterTitle = document.querySelector("meta[name='twitter:title']");
  if (twitterTitle) {
    twitterTitle.setAttribute(
      "content",
      "WhatsApp Solutions for Every Industry | ONBBITS"
    );
  }

    const twitterDesc = document.querySelector(
    "meta[name='twitter:description']"
  );
  if (twitterDesc) {
    twitterDesc.setAttribute(
      "content",
      "Discover industry-specific WhatsApp automation for healthcare, education, retail, real estate, finance and more with ONBBITS."
    );
  }

    const twitterImage = document.querySelector("meta[name='twitter:image']");
  if (twitterImage) {
    twitterImage.setAttribute(
      "content",
      "https://onbbits.io/Images/templates.webp"
    );
  }
  }, [])

    return(
        <>

<SchemaMarkup
  data={CollectionPageSchema({
    name: "Industries",
    description:
      "Discover how ONBBITS WhatsApp automation solutions help businesses across different industries improve customer engagement, communication, and sales.",
    url: "https://onbbits.io/industries/"
  })}
/>

<SchemaMarkup
  data={ItemListSchema({
    name: "Industries Served by ONBBITS",
    items: [
      {
        name: "Healthcare & Clinics"
      },
      {
        name: "Real Estate"
      },
      {
        name: "E-commerce & D2C"
      },
      {
        name: "Finance & Insurance"
      },
      {
        name: "Restaurants & F&B"
      },
      {
        name: "Retail Stores"
      },
         {
        name: "Automobile Dealers"
      },
      {
        name: "Salons & Spas"
      },
      {
        name: "Events & Webinars"
      }
    ]
  })}
/>

<SchemaMarkup
  data={BreadcrumbSchema({
    items: [
      {
        name: "Home",
        url: "https://onbbits.io/"
      },
      {
        name: "Industries",
        url: "https://onbbits.io/industries/"
      }
    ]
  })}
/>

      <SchemaMarkup
  data={WebPageSchema({
    type: "WebPage",
    name: "Industries Served by ONBBITS",
    description:
      "Discover how ONBBITS WhatsApp automation solutions help businesses across different industries improve customer engagement, communication, and sales.",
    url: "https://onbbits.io/industries/"
  })}
/>

         {/**BREADCRUMB */}
        <Breadcrumb title="No matter your industry, ONBBITS fits" />

        {/**CHOOSE YOUR INDUSTRY - CARDS SECTION */}
<section className="choose-industry-section container">
      <div className="choose-industry-top">

        <motion.div
          className="choose-industry-left"
          variants={headingVariant}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <h2 className="section-heading">
            Choose Your Industry.
            <br />
            Explore the <span>Perfect Workflow.</span>
          </h2>
        </motion.div>

        <motion.div
          className="choose-industry-right"
          variants={textVariant}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <p className="section-text">
            Every industry has unique customer journeys. onbbits transforms
            WhatsApp into an intelligent automation platform that captures
            every conversation, responds instantly, qualifies leads, and
            scales customer engagement—24/7.
          </p>
        </motion.div>

      </div>

      <motion.div
        className="choose-industry-grid"
        variants={gridVariant}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
      >
       {chooseYourIndustry.map((item, i) => (
            <IndustryCard key={i} item={item} />
          ))}
      </motion.div>
    </section>

    {/**AUTOMATION BUILT FOR EVERY INDUSTRY SECTION */}
    <IndustryTabs />

         {/**AUTOMATE YOUR WHATSAPP SECTION */}
        <WhatsappAutomationSteps />

        {/**TESTIMONIALS */}
        <Testimonials />

        <div style={{marginTop:"80px"}}></div>

         {/**CTA SECTION */}
        <Cta />
        </>
    )
}
export default Industries;